import { Grid } from '@mui/material';
import { deleteUserRoleApi, getUserByRoleIdAndInstApi, postSaveUserRoleApi } from 'api/user';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import UserCustomDataTable from '../user/UserCustomDataTable';

import { getObjectListApi, getObjectListByPropertyApi } from 'api/general';
import RoleUserPartcListDialog from 'app/components/Dialog/RoleUserPartcListDialog';
import RoleUserList from 'app/components/List/RoleUserList';
import LoadingPopUp from 'app/components/LoadingPopup';
import { getUserFullName } from 'app/utils/appHelpers';
import { GATE_USER, USER_ROLE } from 'app/utils/constants/customConstant';
import Swal from 'sweetalert2';

const RoleUserParticipantManPage = () => {


  const [loading, setLoading] = useState(true);
  const hightCoordinator = useSelector(state => state.auth.authUser);
  const [userList, setUserList] = useState([]);

  const [meetingUserList, setMeetingUserList] = useState([]);
  const [participantUserList, setParticipantUserList] = useState([]);
  const [selectedInst, setSelectedInst] = useState();
  const [inst, setInst] = useState(hightCoordinator.inst);
  const authUser = useSelector(state => state.auth.authUser);
  const [selectedUser, setSelectedUser] = useState(false);
  const [roleDialogStatus, setRoleDialogStatus] = useState(false);
  const [loadingProcess, setLoadingProcess] = useState(false);
  const type = "userParticipant";



  useEffect(() => {

    const getAPI = async () => {

      setLoading(true)
      setInst(hightCoordinator.inst)
      const userRoles = hightCoordinator.userRoles;
      const superUser = userRoles.find(x => x.id === 1);

      const resultMeetingUsers = await getUserByRoleIdAndInstApi(100, "all");
      setMeetingUserList(resultMeetingUsers.data)

      const resultParticipantUsers = await getUserByRoleIdAndInstApi(104, "all");
      setParticipantUserList(resultParticipantUsers.data)

      const resultUserList = await getObjectListApi(GATE_USER);

      setUserList(resultUserList.data)
      if (superUser !== undefined) {
        setInst(false)
      }

      setLoading(false)

    }
    getAPI();
  }, [])


  const handleDeleteCoordinatorRole = async (roleId, user) => { // unitsiz 368 ve 373 için

    Swal.fire({
      title: 'Rol Silme İşlemi',
      text: "Rolü silmek istediğinizden emin misiniz?",
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet Sil',
      cancelButtonText: "Vazgeç"
    }).then(async (result) => {

      if (result.isConfirmed) {
        setLoadingProcess(true)
        result = await deleteUserRoleApi({ id: user.userRoleId })

        if (result.status) {
          if (roleId === 100) {
            const filteredList = meetingUserList.filter(x => x.userRoleId !== user.userRoleId);

            const removedUser = meetingUserList.find(x => x.userRoleId === user.userRoleId);
            if (removedUser) {
              setUserList(prevUserList => [...prevUserList, removedUser]);
            }
            setMeetingUserList(filteredList);
          } else if (roleId === 104) {
            const filteredList = participantUserList.filter(x => x.userRoleId !== user.userRoleId);
            setParticipantUserList(filteredList);
          }
        }

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Silme işlemi başarılı.',
          showConfirmButton: false,
          timer: 1500
        });

        setLoadingProcess(false)

      }
    })

  }


  const handleCloseRole = async (roleId) => {


    if (roleId === false || !roleId || roleId === undefined) {
      handleDialogClose();
      return;
    }

    if (roleId !== undefined) {


      Swal.fire({
        title: 'Rol Ekleme İşlemi',
        text: "Rolü eklemek istediğinizden emin misiniz?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Evet Ekle',
        cancelButtonText: "Vazgeç"
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoadingProcess(true)



          const res = await getObjectListByPropertyApi(USER_ROLE, "userId", selectedUser.id)
          const roles = res.data
          const role = roles.find(role => role.roleId === roleId)
          if (role) {
            setLoadingProcess(false)

            Swal.fire({
              title: 'Rol Ekleme İşlemi',
              text: "Daha önce bu rol verilmiş.",
              icon: 'error',
              showConfirmButton: false,
              timer: 2000
            })

            handleDialogClose();
          }
          else {

            const result = await postSaveUserRoleApi({ userId: selectedUser.id, roleId, inst: "", customId: 0, addedUserId: authUser.id, addedDate: new Date() })
            if (result.status) {

              Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'İşlem başarılı.',
                showConfirmButton: false,
                timer: 1500
              });

              handleDialogClose();
              setLoadingProcess(false)

            }

          }




        } else {
          setRoleDialogStatus(false);
        }
      })
    }

  };

  const columnData = [
    { id: 'id', align: 'center', disablePadding: false, label: 'Resim' },
    { id: 'title', align: 'center', disablePadding: true, label: 'Ünvan Ad Soyad' },
    { id: 'islemler', align: 'center', disablePadding: false, label: 'İşlemler' },
  ];

  const handleDialogClose = () => {
    setRoleDialogStatus(false);
  };


  return (

    <div>

      <LoadingPopUp open={loading} />

      {!loading && (
        <>

          <Grid container >
            <Grid container spacing={3.75}>

              <Grid item xs={12} sm={12} lg={12}>
                <LoadingPopUp open={loadingProcess} />
              </Grid>
              <Grid item xs={6} sm={6} lg={6} >


                <UserCustomDataTable mainData={userList} column={columnData} pageTitle="Tüm Kullanıcı Listesi" setSelectedUser={setSelectedUser} setRoleDialogStatus={setRoleDialogStatus} />


              </Grid>

              <Grid item xs={6} sm={3} lg={3} >
                <Grid container spacing={3.75}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <RoleUserList
                      key={meetingUserList.length}
                      title={'Üye Rolü Listesi'}
                      userList={meetingUserList}
                      handleDeleteUser={(user) => handleDeleteCoordinatorRole(100, user)}
                    />
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xs={6} sm={3} lg={3} >
                <Grid container spacing={3.75}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <RoleUserList
                      key={participantUserList.length}
                      title={'Katılımcı Rolü Listesi'}
                      userList={participantUserList}
                      handleDeleteUser={(user) => handleDeleteCoordinatorRole(104, user)}
                    />
                  </Grid>

                </Grid>
              </Grid>

            </Grid>
          </Grid>


          <RoleUserPartcListDialog
            type={type}
            open={roleDialogStatus}
            userParticipant={roleDialogStatus}
            selectedValue={selectedInst}
            setSelectedValue={setSelectedInst}
            inst={inst}
            onClose={handleDialogClose}
            handleCloseRole={handleCloseRole}
            pageTitle={getUserFullName(selectedUser)}
          />


        </>
      )}
    </div>


  )
}

export default RoleUserParticipantManPage
